import {initMixpanel} from 'common/report/tracking-setup';
import {reporter} from 'common/report/error-reporting';

const mixpanel = initMixpanel(PROJECT_3_MIXPANEL_TOKEN);

export const enum TrackEvents {
  ViewStartupsApplyPage = `Viewed Startup Scholarship application`,
  ViewStartupsThankYou = `Viewed Startup Scholarship Thank You`,
  ClickStartupApplyNowButton = `Click Startup Apply Now Buttton`,
  SubmitStartupsApplication = `Startup Program Application Submitted`,
  StartupProgramEnrolled = `Startup Program Enrolled`,
  ReapplyStartupProgram = `Startup Program Already Enrolled`,
  RejectedByStartupProgram = `Startup Program Not Eligible`,
  ViewResetPasswordPage = `Viewed reset password page`,
  StartupApplyToFreePlan = `Clicked Free plan link on Startup Scholarship application`,
  StartupApplyToPlanBuilder = `Clicked plan builder link on Startup Scholarship`,
  StartupApplyToPlanDetail = `Clicked plan detail link on Startup Scholarship`,
}

export const enum TrackProperties {
  IsLoggedIN = `Is Logged In`,
  IneligibleReason = `Ineligible Reason`,
  ReferralPartner = `Referral Partner`,
}

export function track(eventName: TrackEvents, properties = {}): void {
  try {
    mixpanel.track(eventName, properties);
  } catch (err) {
    reporter.error(`tracking error`, err);
  }
}
